import React, { useState } from "react";
import { Card, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Button from "../../Subcomponents/Button";
import cssClasses from "./EMandate.module.css";
import actions from "../../Redux Store/actions";
import { useDispatch } from "react-redux";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { errorTost } from "../../Services/Toast";

import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { useEffect } from "react";
import EMandateStepper from "./EMandateStepper";
import {
  getApplicantsForEmandate,
} from "../../Services/Allotment";

// 🔹 Back button style (used in both sections)
const backBtnStyle = {
  height: "48px",
  borderRadius: "12px",
  border: "1px solid #d1d5db",
  backgroundColor: "#ffffff",
  color: "#0f172a",
  boxShadow: "none",
  fontSize: "1.52rem",
};

// 🔹 Continue button style (Primary Applicant → Bank Details)
const continueBtnStyle = {
  height: "48px",
  borderRadius: "12px",
  border: "none",
  backgroundColor: "#94a3b8", // disabled grey look
  color: "#ffffff",
  fontSize: "1.52rem",
};

const COLORS = {
  completed: "#16A34A", // green (✔)
  active: "#1F3A5F", // dark navy (2)
  inactive: "#E5E7EB", // light gray (3,4)
  lineActive: "#16A34A", // green line
  lineInactive: "#E5E7EB",
  textActive: "#0F172A",
  textInactive: "#64748B",
};

const SingleApplicant = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();

  const totalMandateAmount = location.state?.totalMandateAmount || 0;
  // console.log("totalMandateAmount  in Single Applicant ", totalMandateAmount);
  const bookingId = location.state?.bookingId;
  // console.log("bookingId  in Single Applicant ", bookingId);
  const allotment = location.state?.allotment;
  const allotmentPaymentId = location.state?.allotmentPaymentId;
  // console.log("allotmentPaymentId  in Single Applicant ", allotmentPaymentId);
  // console.log("allotment in Single Applicant====>", allotment);

  // ✅ Active step (2 in screenshot)
  const [activeStep, setActiveStep] = useState(1);
  const [splitSection, setSplitSection] = useState(1);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [selectedApplicantData, setSelectedApplicantData] = useState(null);
  const [applicants, setApplicants] = useState([]);

  TimeAgo.setDefaultLocale(en.locale);
  TimeAgo.addLocale(en);

  useEffect(() => {
    dispatch(actions.activeMenu("emandateallotments"));
  }, [dispatch]);

  //get applicants data from agreementform table
  useEffect(() => {
    const fetchApplicants = async () => {
      try {
        console.log(
          "Single applicant → allotmentPaymentId:",
          allotmentPaymentId,
        );

        if (!allotmentPaymentId) {
          console.warn("No allotmentPaymentId found");
          return;
        }

        const agreementForm =
          await getApplicantsForEmandate(allotmentPaymentId);

        console.log("Single applicant → agreementForm:", agreementForm);

        const applicantsFromDB = agreementForm?.applicants || [];

        // const equalPercentage = Math.floor(100 / applicantsFromDB.length);

        const mappedApplicants = applicantsFromDB.map((item, index) => {
          const a = item.applicant;

          return {
            id: index + 1,
            name: a.nameAsperPAN,
            pan: a.panNumber,
            percentage: 100,
            nameAsPerPan: a.nameAsperPAN,
            contactNumber: a.contactNumber,
            email: a.email,
          };
        });
        console.log("mappedApplicants", mappedApplicants);

        setApplicants(mappedApplicants);
      } catch (err) {
        console.error("Failed to fetch applicants for eMandate", err);
      }
    };

    fetchApplicants();
  }, [allotmentPaymentId]);

  const handleBankVerfication = async () => {
    console.log("selected applicant data --->", selectedApplicantData);
    setSplitSection(2);

    try {
      let totalPercentage = selectedApplicantData.percentage || 0;
      console.log("Total Percentage:", totalPercentage);
      // Decide the value of isSplit based on the total percentage
      const isSplit =
        totalPercentage === selectedApplicantData?.percentage ? false : true;
      console.log("isSplit in split amount :", isSplit);

      const splitRatio = selectedApplicantData?.percentage; // Split ratio for active applicants

      // Calculate % of the total amount
      const splitAmount = totalMandateAmount * (splitRatio / 100);
      console.log("Split Amount in split amount :", splitAmount);

      // Add calculated values to selectedApplicantData
      selectedApplicantData.calculatedPercentage = totalPercentage;
      selectedApplicantData.splitAmount = splitAmount;
      selectedApplicantData.splitRatio = splitRatio;

      // Now, selectedApplicantData will include the new calculated properties
      console.log("Updated selectedApplicantData:", selectedApplicantData);
      
      navigate("/Home/BankVerification", {
        state: {
          currentIndex: 0, // always 0 for single applicant
          currentApplicant: [selectedApplicantData],
          allotment,
          totalMandateAmount,
          bookingId,
          allotmentPaymentId,
        },
      });
    } catch (error) {
      console.log("error ", error);
    }
    // Step 1: Get percentage directly (no array)
    // const totalPercentage = selectedApplicantData?.percentage;

    // if (totalPercentage === 100) {
    //   const totalMandateAmount = location.state?.totalMandateAmount || 0;

    //   // Step 2: Calculate mandate amount
    //   const singleMandateAmount = Math.round(
    //     (totalMandateAmount * totalPercentage) / 100,
    //   );

    //   // Step 3: Prepare single insert payload (NOT array)
    //   const insertPayload = {
    //     allotmentPaymentId: allotmentPaymentId,
    //     crmId: allotment?.CRM?.[0]?.id || null,
    //     name: selectedApplicantData.name,
    //     pan: selectedApplicantData.pan,
    //     splitRatio: totalPercentage,
    //     emandateAmount: singleMandateAmount,
    //     emandateStatus: "Pending",
    //     consumerId: `${bookingId || ""}${selectedApplicantData?.pan || ""}`,
    //     isSplit: false, // single applicant → always false
    //   };

    //   console.log("Insert eMandate Details Payload:", insertPayload);

    //   const result = await insertSingleEmandateDetailsRecord(insertPayload); // Function that inserts data into DB
    //   console.log("result in single applicant----->", result);

    //   // Step 5: Check if the insertion was successful
    //   if (result.isInserted === false) {
    //     // Show toast with the message from result
    //     errorTost(result.message); // Show warning if insertion is skipped
    //   } else {
    //     console.log("eMandate details inserted/updated successfully.");

    //     // Since this is single applicant flow,
    //     // result is an object, not array

    //     if (!result.isInserted) {
    //       console.log("Mandate failed.");
    //       return;
    //     }

    //     // Assuming `result` contains the `insertedData` and `updatedData`, and `selectedApplicantData` has the `contactNumber`

    //     const combinedData = {
    //       ...result.insertedData[0], // Spread insertedData properties
    //       ...result.updatedData, // Spread updatedData properties
    //       contactNumber: selectedApplicantData?.contactNumber, // Add contactNumber
    //     };

    //     console.log("Combined Data in single applicant :", combinedData);

    //     // Navigate
    //     navigate("/Home/BankVerification", {
    //       state: {
    //         // splitData: combinedData,
    //         currentIndex: 0, // always 0 for single applicant
    //         currentApplicant: combinedData,
    //         allotment,
    //         totalMandateAmount,
    //         bookingId,
    //         allotmentPaymentId,
    //         // selectedApplicantData: combinedData,
    //       },
    //     });
    //   }
    // } else {
    //   console.log("The total percentage of both applicants must equal 100.");

    //   // Display error toast if the total percentage is not 100%
    //   // errorTost(
    //   //   "The total percentage of both applicants must equal 100%. Please adjust the percentages.",
    //   // );
    // }
  };

  return (
    <div style={{ overflow: "auto" }}>
      <div className={cssClasses.pageWrapper}>
        {/* ───────── STEPPER ───────── */}
        <EMandateStepper activeStep={activeStep} />
        <div className={cssClasses.wrapper}>
          <div className={cssClasses.header}>
            <h2>Select Primary Applicant</h2>
            <p>
              The entire payment schedule will be linked to this applicant's
              bank account.
            </p>
          </div>
          <Card className={cssClasses.amountCard} elevation={0}>
            <span>Total Mandate Amount</span>
            <strong>₹{numberWithCommas(totalMandateAmount)}</strong>
          </Card>

          {/* Applicant 1 */}
          {applicants.map((applicant) => (
            <div
              key={applicant.id}
              className={`${cssClasses.applicantCard} ${
                selectedApplicant === applicant.id ? cssClasses.selected : ""
              }`}
              onClick={() => {
                setSelectedApplicant(applicant.id);
                setSelectedApplicantData(applicant);
              }}
            >
              <div className={cssClasses.applicantLeft}>
                <PeopleOutlineIcon
                  sx={{ fontSize: "14px", height: 25, width: 25 }}
                />
                <div>
                  <div className={cssClasses.applicantName}>
                    {applicant.nameAsPerPan}
                  </div>
                  <div className={cssClasses.applicantEmail}>
                    {applicant.pan}
                  </div>
                </div>
              </div>
              <input
                type="radio"
                checked={selectedApplicant === applicant.id}
                readOnly
              />
            </div>
          ))}

          {/* Footer Buttons */}
          <div className={cssClasses.footerRow}>
            <Button
              btnName="Back"
              style={backBtnStyle}
              clicked={() => navigate("/Home/EMandate")}
            />
            <Button
              btnName="Continue"
              disable={!selectedApplicant}
              style={{
                ...continueBtnStyle,
                backgroundColor: selectedApplicant ? "#163475ff" : "#94a3b8",
              }}
              clicked={handleBankVerfication}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleApplicant;
